module.exports = __webpack_public_path__ + "static/media/pic2.bc88da6f.jpg";